export const API_URL_PLACEHOLDER = 'amagnoapi.de';
